export const NATIVE_STANDARD_INTERFACE_ID = 'ua-platform-native';
export const NOTIFICATION_PAGE_ID = 'ua_platform_native_notifications';
export const NOTIFICATION_PAGE_SLUG = 'notifications';
